import { isEqual } from 'lodash';
import { isDraftContent, isRichContent } from '../types/contentTypes.js';
import { truncateRichContent } from './ricos-truncate.js';
export { getCountableNodes } from './ricos-truncate.js';
import '../Either-48abb652.js';
import '../ReadonlyNonEmptyArray-0e481d0b.js';
import '../Tuple-2f69c1c7.js';
import 'ricos-schema';
import '../fp-utils-24a5cc96.js';
import '../RicosContentAPI/extract.js';
import '../extractor-infra.js';
import '../index-a60c253d.js';
import '../ReadonlyRecord-86a56753.js';
import '../string-40bcd6bf.js';
import '../RicosContentAPI/modify.js';
import '../modifier-infra.js';
import '../converters/generateRandomId.js';
import '../utils.js';
import '../visitNodes/index.js';
import './types.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const toLimits = (limits) => {
  var _a, _b, _c;
  return {
    nodeCount: (_a = limits.blocksCount) != null ? _a : Infinity,
    wordCount: (_b = limits.wordsCount) != null ? _b : Infinity,
    maxPlugins: (_c = limits.maxPlugins) != null ? _c : Infinity
  };
};
const truncateContent = (content, limits, options) => {
  if (isDraftContent(content)) {
    return truncateDraftContent(content, limits);
  }
  if (isRichContent(content)) {
    const truncatedContent = truncateRichContent(content, toLimits(limits), options);
    const isTruncated = !isEqual(content, truncatedContent);
    return { content: truncatedContent, isTruncated };
  }
  return { content, isTruncated: false };
};
const truncateDraftContent = (content, limits = {}) => {
  const { blocks, entityMap } = content;
  const { wordsCount = Infinity, maxPlugins = Infinity, blocksCount = Infinity } = limits;
  if (blocksCount < 0 || blocksCount > blocks.length && wordsCount === Infinity && maxPlugins === Infinity) {
    return { content, isTruncated: false };
  }
  const newEntityMap = {};
  const BreakException = {};
  const newBlocks = [];
  let cWordCount = 0;
  let pluginsCount = 0;
  let isTruncated = false;
  try {
    blocks.forEach((block, i) => {
      if (i === blocksCount)
        throw BreakException;
      const blockWords = block.text.split(" ").filter((x) => x !== "");
      if (block.type === "atomic") {
        pluginsCount++;
      }
      if (pluginsCount > maxPlugins) {
        throw BreakException;
      }
      if (cWordCount + blockWords.length > wordsCount) {
        newBlocks.push(__spreadProps(__spreadValues({}, block), {
          text: blockWords.slice(0, wordsCount - cWordCount).join(" ") + "\u2026"
        }));
      } else {
        newBlocks.push(block);
      }
      cWordCount += blockWords.length;
      block.entityRanges.forEach((entity) => {
        newEntityMap[entity.key] = entityMap[entity.key];
      });
      if (cWordCount >= wordsCount)
        throw BreakException;
    });
  } catch (e) {
    if (e !== BreakException)
      throw e;
    isTruncated = true;
  }
  const truncatedContent = __spreadProps(__spreadValues({}, content), { blocks: newBlocks, entityMap: newEntityMap });
  return { content: truncatedContent, isTruncated };
};

export { truncateContent };
//# sourceMappingURL=index.js.map
